import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABar, CTAButtonOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { ArrowRightIcon, UsersIcon, LeafIcon, DollarSignIcon, ThumbsUpIcon, ShieldCheckIcon, SparklesIcon, HomeIcon, SunIcon, ClockIcon, SearchIcon, EyeIcon, ZapIcon, WrenchIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function WindowCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-2097">
      <Navbar data-id="element-2098" />
      <main data-id="element-2099">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Window Cleaning" subheadline="To maintain that squeaky clean glass look we provide window cleaning service. Not only will we leave your windows spotless, we make sure to clean the surrounding areas as well." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Get Started',
        href: '#contact'
      }} data-id="element-2100" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2101">
          <div className="max-w-7xl mx-auto" data-id="element-2102">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-2103">
              <div className="w-full lg:w-1/2" data-id="element-2104">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-2105">
                  <img src="https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp" alt="Window Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-2106" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-2107">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-2108">
                  Window Cleaning
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-2109">
                  At BlueCactus Power Washing, we offer top-notch power washing
                  services for both residential and commercial properties. Our
                  team of experienced professionals utilizes industry-leading
                  equipment and eco-friendly cleaning solutions to deliver
                  exceptional results. We specialize in removing dirt, grime,
                  and other stubborn materials from surfaces such as driveways,
                  sidewalks, patios, and building exteriors.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-2110" />

        {/* Section — Crystal Clear Windows */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2111">
          <div className="max-w-4xl mx-auto text-center" data-id="element-2112">
            <h2 className="font-bold mb-8" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2113">
              Window Cleaning Services: Crystal Clear Windows for a Beautiful
              Home
            </h2>
            <p className="mb-4" style={bodyStyle} data-id="element-2114">
              Clean windows can dramatically improve the appearance of your
              home, enhancing its curb appeal and allowing natural light to
              brighten your living space. However, over time, windows accumulate
              dirt, grime, hard water spots, and streaks that not only block
              your view but can also damage the glass. Our professional window
              cleaning service ensures that your windows are spotless,
              streak-free, and sparkling, allowing your home to shine inside and
              out.
            </p>
            <p style={bodyStyle} data-id="element-2115">
              Our window cleaning service goes beyond just wiping down the
              glass. We provide a thorough and meticulous cleaning process that
              leaves your windows looking like new, while also extending their
              lifespan. Whether you need exterior, interior, or both cleaned, we
              use safe, eco-friendly products and techniques to achieve
              crystal-clear results on every job.
            </p>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-2116" />

        {/* Section — What's Included */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2117">
          <div className="max-w-7xl mx-auto" data-id="element-2118">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2119">
              Comprehensive Window Cleaning Solutions
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-2120">
              Here's what you can expect from our window cleaning service:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2121">
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2122">
                <div className="flex items-center gap-4 mb-4" data-id="element-2123">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2124">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2125">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2126">
                    Exterior Window Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2127">
                  The exterior of your windows is constantly exposed to the
                  elements, causing them to become dirty and grimy. Dust,
                  pollen, bird droppings, and water stains can build up on the
                  surface. Our professional team uses high-quality cleaning
                  solutions and specialized equipment to wash away the dirt,
                  leaving your windows crystal clear. For hard-to-reach windows,
                  we use telescopic poles or ladders to safely access every
                  corner.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2128">
                <div className="flex items-center gap-4 mb-4" data-id="element-2129">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2130">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2131">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2132">
                    Interior Window Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2133">
                  Interior windows can collect fingerprints, smudges, and dust,
                  especially in high-traffic areas like kitchens, living rooms,
                  and bathrooms. Our team carefully cleans the inside of your
                  windows, ensuring they are streak-free and spotless. We also
                  take extra care to protect your furnishings and floors during
                  the process, so there's no mess left behind.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2134">
                <div className="flex items-center gap-4 mb-4" data-id="element-2135">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2136">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2137">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2138">
                    Screen Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2139">
                  Dirty or clogged window screens can block airflow and reduce
                  visibility, even if your windows are clean. As part of our
                  service, we remove, clean, and reinstall your window screens
                  to ensure they are free of dust, pollen, and debris. This
                  improves the clarity of your windows and allows for better
                  ventilation throughout your home.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2140">
                <div className="flex items-center gap-4 mb-4" data-id="element-2141">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2142">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2143">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2144">
                    Sill, Frame, and Track Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2145">
                  In addition to cleaning the glass, we also clean window sills,
                  frames, and tracks. Dirt, insects, and debris can accumulate
                  in these areas, leading to mold growth or operational issues.
                  We carefully wipe down and remove buildup from these areas,
                  leaving your windows fully functional and clean from top to
                  bottom.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2146">
                <div className="flex items-center gap-4 mb-4" data-id="element-2147">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2148">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2149">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2150">
                    Hard Water Spot Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2151">
                  Hard water spots can be difficult to remove with standard
                  cleaning methods and can cause long-term damage to your
                  windows if not treated. We use specialized solutions designed
                  to dissolve hard water stains without scratching or damaging
                  the glass, restoring the clarity of your windows and
                  preventing permanent etching.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-2152">
                <div className="flex items-center gap-4 mb-4" data-id="element-2153">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-2154">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-2155">
                      6
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2156">
                    Streak-Free Guarantee
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-2157">
                  We understand that streaks are the biggest frustration when it
                  comes to window cleaning. That's why we guarantee a
                  streak-free finish on every job. Our team uses the best
                  squeegees, microfiber cloths, and techniques to ensure a
                  perfect clean every time.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButtonOnBlue data-id="element-2158" />

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2159">
          <div className="max-w-7xl mx-auto" data-id="element-2160">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2161">
              Why Choose Our Window Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2162">
              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2163">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2164">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-2165" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2166">
                  Experienced Professionals
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2167">
                  Our trained technicians have years of experience in
                  residential and commercial window cleaning, ensuring you
                  receive top-quality service every time.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2168">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2169">
                  <LeafIcon className="h-6 w-6 text-white" data-id="element-2170" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2171">
                  Eco-Friendly Cleaning Solutions
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2172">
                  We use environmentally safe, non-toxic cleaning products that
                  effectively remove dirt and grime without leaving harmful
                  residue behind.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2173">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2174">
                  <SearchIcon className="h-6 w-6 text-white" data-id="element-2175" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2176">
                  Attention to Detail
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2177">
                  We clean more than just the glass. We take the time to clean
                  window sills, frames, tracks, and screens, ensuring your
                  entire window system is spotless.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2178">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2179">
                  <ShieldCheckIcon className="h-6 w-6 text-white" data-id="element-2180" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2181">
                  Safe and Reliable
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2182">
                  Our team follows strict safety protocols, especially when
                  working at heights. We use industry-approved equipment and
                  techniques to clean even the most challenging windows safely.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2183">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2184">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-2185" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2186">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2187">
                  We offer competitive pricing and transparent quotes for all
                  our window cleaning services, so you know exactly what to
                  expect with no hidden fees.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2188">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2189">
                  <ThumbsUpIcon className="h-6 w-6 text-white" data-id="element-2190" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2191">
                  Satisfaction Guaranteed
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2192">
                  We are committed to providing 100% customer satisfaction. If
                  you're not happy with the results, we'll come back and make it
                  right, no questions asked.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-2193" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2194">
          <div className="max-w-7xl mx-auto" data-id="element-2195">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2196">
              Benefits of Professional Window Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-2197">
              <div className="flex gap-5" data-id="element-2198">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2199">
                  <HomeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2200" />
                </div>
                <div data-id="element-2201">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2202">
                    Enhances Curb Appeal
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2203">
                    Clean windows can transform the appearance of your home,
                    giving it a fresh, well-maintained look from the outside.
                    Sparkling windows make a significant impact.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2204">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2205">
                  <SunIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2206" />
                </div>
                <div data-id="element-2207">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2208">
                    Improves Indoor Lighting
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2209">
                    Dirt and grime on windows block natural light from entering
                    your home. Clean windows allow more sunlight to fill your
                    rooms, creating a brighter, more inviting living space.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2210">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2211">
                  <WrenchIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2212" />
                </div>
                <div data-id="element-2213">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2214">
                    Extends Window Lifespan
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2215">
                    Regular window cleaning helps prevent the buildup of dirt,
                    mold, and hard water stains that can cause long-term damage
                    to the glass and frames, extending their lifespan.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2216">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2217">
                  <ZapIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2218" />
                </div>
                <div data-id="element-2219">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2220">
                    Boosts Energy Efficiency
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2221">
                    Dirt on windows can interfere with the sun's ability to heat
                    your home naturally. Clean windows improve energy efficiency
                    by allowing more warmth and light to penetrate your living
                    spaces.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2222">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2223">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2224" />
                </div>
                <div data-id="element-2225">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2226">
                    Prevents Glass Degradation
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2227">
                    Over time, dirt and grime can etch into glass, causing
                    permanent damage and reducing visibility. Routine cleaning
                    helps prevent this degradation, ensuring your windows remain
                    clear.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2228">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2229">
                  <ClockIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2230" />
                </div>
                <div data-id="element-2231">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2232">
                    Saves Time and Effort
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2233">
                    Cleaning windows yourself can be time-consuming and
                    challenging, especially for larger homes or hard-to-reach
                    windows. By hiring professionals, you save time and
                    frustration.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Types of Windows */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2234">
          <div className="max-w-7xl mx-auto" data-id="element-2235">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2236">
              Types of Windows We Clean
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2237">
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2238">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2239">
                  Single- and Double-Hung Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2240">
                  Our team efficiently cleans both the interior and exterior
                  panes of single- and double-hung windows, ensuring no streaks
                  or smudges are left behind.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2241">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2242">
                  Casement Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2243">
                  We thoroughly clean the glass and frames of casement windows,
                  paying special attention to the hardware and tracks to keep
                  them functional.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2244">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2245">
                  Bay and Bow Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2246">
                  These multi-pane windows can be challenging to clean, but our
                  experienced technicians handle them with ease, ensuring a
                  spotless finish across all panes.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2247">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2248">
                  Sliding Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2249">
                  We clean both the glass and tracks of sliding windows to
                  ensure smooth operation and a clean, clear view.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2250">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2251">
                  Skylights and High Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2252">
                  Our team has the tools and expertise to safely clean skylights
                  and high windows that are difficult to reach, ensuring no spot
                  is overlooked.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-2253">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2254">
                  Storm Windows
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2255">
                  We carefully remove, clean, and reinstall storm windows,
                  ensuring both layers of glass are sparkling and free of
                  debris.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Regular Maintenance */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2256">
          <div className="max-w-4xl mx-auto text-center" data-id="element-2257">
            <h2 className="font-bold mb-6" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2258">
              Regular Window Maintenance
            </h2>
            <p className="mb-6" style={bodyStyle} data-id="element-2259">
              We recommend regular window cleaning at least twice a year to keep
              your windows looking their best and functioning properly. Whether
              you need a seasonal clean or more frequent maintenance, we offer
              flexible scheduling options to meet your needs.
            </p>
            <p style={bodyStyle} data-id="element-2260">
              Don't let dirty windows detract from the beauty of your home. Our
              professional window cleaning service will leave your windows
              sparkling, streak-free, and crystal clear.
            </p>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2261">
          <div className="max-w-7xl mx-auto" data-id="element-2262">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-2263">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-2264">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-2265">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2266">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-2267" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-2268">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2269">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-2270" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready for Spotless Windows?" data-id="element-2271" />
      </main>
      <Footer data-id="element-2272" />
    </div>;
}